export const ATTENDANCE_STATUS = {
  PRESENT: 1,
  ABSENT: 2,
};

export const ATTENDANCES = {
  [ATTENDANCE_STATUS.PRESENT]: {
    COLOR_CODE: "#00CC88",
    TITLE: "Attended",
  },
  [ATTENDANCE_STATUS.ABSENT]: {
    COLOR_CODE: "#EF233C",
    TITLE: "Absent",
  },
};
